import styled from 'styled-components';

export const Container = styled.div`
    padding: 10px 0px 0px 20px;
    width: calc(100% - 290px);
    flex-basis: 100%;
`;
